module.exports = __webpack_public_path__ + "img/jwgl-htgl-jcsj.b2e5f008.png";